import { __assign } from "tslib";
export var generateDataAttr = function (props, filter) {
    return Object.entries(props)
        .filter(function (_a) {
        var key = _a[0];
        return filter && filter.includes(key);
    })
        .reduce(function (output, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, output), (_b = {}, _b["data-".concat(key.toLowerCase())] = value, _b)));
    }, {});
};
//# sourceMappingURL=generateDataAttr.js.map